<template>
    
<div class="row" v-if="this.search == 'all' || search == 'news'">
    <div class="col-12">

        <h2 class="section__title mb-5">{{title}}</h2>

        <div class="card-deck card-deck--three">

            <a class="card card--news" :href="item.url" :target="item.target" v-for="(item, index) in computedItems" :key="index">
                <div class="card__header">
                    <div class="card__date" v-html="$textHighlight(item.date, this.keyword)"></div>
                    <div class="card__title" v-html="$textHighlight(item.title, this.keyword)"></div>
                </div>
                <div class="card__image">
                    <img :src="item.image" :alt="item.title" loading="lazy">
                </div>                
            </a>

        </div>

        <p v-if="items.length == 0">
            <span v-if="keyword">"<b>{{ keyword }}</b>" -</span> {{textnoresult}}
        </p>
        
    </div>
</div>

</template>


<script>

let axios = require('axios')

export default {
    props: [
        'items',
        'title',
        'search',
        'keyword',
        'textreadmore',
        'textviewmore',
        'textnoresult',
        'token',
        'lang',
    ],

    data() {
        return {
            limit : 6,
        }
    },

    computed:{
        computedItems(){
            return (this.search == 'all' && !this.keyword ) ? this.items.slice(0,this.limit) : this.items;
        },
    },

    watch: {
        keyword() {
            this.getNews();
        },
        search() { 
            this.getNews();
        },
    },

    methods: {

        getNews() {

            if(this.search == 'news') {
                var vm = this;
                vm.$emit('setLoading', 'preloader-search--reload');

                let $endpoint = `/api/${vm.lang}/search/news?token=${vm.token}&keyword=${vm.keyword}`;
                axios.get($endpoint).then(function (response) {

                    vm.$emit('updateItems', 'news', response.data.data);

                })
                .catch(function (error) {
                    console.error(error);
                })
                .then(function () {

                    vm.$emit('setLoading', '');
                })
            }

        },

    },

    mounted() {
        // this.getNews();
    },

}

</script>